// extracted by mini-css-extract-plugin
export default {"passwordResetPage":"password-reset-page_passwordResetPage__1YZmu","passwordResetForm":"password-reset-page_passwordResetForm__K-FB3"};